/**
 * Time period options for crypto price charts
 * Used in CryptoDetails component
 */
export const TIME_PERIODS = [
    { value: '3h', label: '3 Hours' },
    { value: '24h', label: '24 Hours' },
    { value: '7d', label: '7 Days' },
    { value: '30d', label: '30 Days' },
    { value: '3m', label: '3 Months' },
    { value: '1y', label: '1 Year' },
    { value: '3y', label: '3 Years' },
    { value: '5y', label: '5 Years' }
];

/**
 * Default time period for charts
 */
export const DEFAULT_TIME_PERIOD = '7d';
